import TextField, { TextFieldProps } from '@mui/material/TextField';
import { PatternFormat, PatternFormatProps } from 'react-number-format';

export type PatternTextFieldProps = Omit<PatternFormatProps, 'size'> & TextFieldProps;

export const PatternTextField = (props: PatternTextFieldProps) => {
    return <PatternFormat {...props} customInput={TextField} />;
};
